import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';


const OrderUnreceivedRule = (props) => {
  const {
    form, type, onSubmit, initialValues, ...other
  } = props;
  const [numberDays, setNumberDays] = useState(initialValues.number_days || 5);
  const [numberDaysStart, setNumberDaysStart] = useState(initialValues.number_days_start || numberDays + 7);
  const [included_supplier_ids, setIncludedSupplierIds] = useState(
    initialValues.included_supplier_ids || []
  );

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'order_unreceived',
      value: {
        number_days: numberDays,
        included_supplier_ids,
        number_days_start: numberDaysStart,
      }
    });
  }, [onSubmit, numberDays, included_supplier_ids, numberDaysStart]);

  const onReset = useCallback(() => {
    setNumberDays(initialValues.number_days || 5);
    setIncludedSupplierIds(initialValues.included_supplier_ids || []);
  }, [initialValues.number_days, initialValues.included_supplier_ids]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineSupplierSelect
        mode='multiple'
        showSearch={true}
        placeholder='All suppliers by default'
        value={included_supplier_ids}
        onChange={setIncludedSupplierIds}
        include_all={false}
        include_any={false}
      />
      <InlineInputNumber
        label='Latest Number of Days to Look Back'
        value={numberDays}
        onChange={setNumberDays}
      />
      <InlineInputNumber
        label='Earliest Number of Days to Look Back'
        value={numberDaysStart}
        onChange={setNumberDaysStart}
      />
    </RuleForm>
  );
};

OrderUnreceivedRule.defaultProps = {
  type: 'add',
  initialValues: {
    number_days: 5,
    number_days_start: 12
  }
};

OrderUnreceivedRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default OrderUnreceivedRule;
